import { Text } from "@ttc3k/trekker";
import { EnumWidgetType } from "gql/generated";
import { i18nNamespace } from "i18n";
import { Trans, useTranslation } from "react-i18next";
import { ActionCard, PreviewModal } from "shared/components";
import { Flex } from "styled-system/jsx";
import EventsWidget from "widgets/events/EventsWidget";
import { OperatorsWidgetContextProvider } from "widgets/operators/components/OperatorsContext";
import OperatorsWidget from "widgets/operators/OperatorsWidget";
import { I18NContextProvider } from "widgets/shared";

type WidgetPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  widgetId: string;
  widgetType: EnumWidgetType;
  organizationWebsite?: string;
  organizationId: string;
};

export const WidgetPreviewModal = ({
  isOpen,
  onClose,
  widgetId,
  widgetType,
  organizationWebsite,
  organizationId,
}: WidgetPreviewModalProps) => {
  const { t } = useTranslation();
  return (
    <PreviewModal
      isOpen={isOpen}
      onClose={onClose}
      urlText={organizationWebsite}
    >
      <I18NContextProvider
        defaultNS={[i18nNamespace.Core, i18nNamespace.Widgets]}
        i18nWidgetType=""
      >
        <Flex flexDir={"column"} gap={"300"} p={"600"}>
          {widgetType === EnumWidgetType.Operator && (
            <ActionCard
              subText={
                <Trans
                  i18nKey={"widgets:PREVIEW_WARNING"}
                  components={{
                    Text: <Text as={"span"} fontWeight={"semiBold"} />,
                  }}
                >
                  {t("widgets:PREVIEW_WARNING")}
                </Trans>
              }
              surfaceProps={{
                borderColor: "border.highlight",
              }}
              bodyProps={{ bg: "bg.highlight.lightest" }}
              textProps={{ color: "text.highlight.dark" }}
              displayCloseButton
            />
          )}
          {widgetType === EnumWidgetType.Operator ? (
            <OperatorsWidgetContextProvider
              widgetId={widgetId}
              organizationId={organizationId}
              displayWidgetName={false}
              gridPageSize={25}
            >
              <OperatorsWidget viewOnly />
            </OperatorsWidgetContextProvider>
          ) : (
            <div style={{ minHeight: "360px" }}>
              <EventsWidget
                organizationId={organizationId}
                widgetId={widgetId}
                viewOnly
              />
            </div>
          )}
        </Flex>
      </I18NContextProvider>
    </PreviewModal>
  );
};
